function validateCpf(cpf) {
    let numeros;
    let digitos;
    let soma;
    let i;
    let resultado;
    let digitosIguais;
    digitosIguais = 1;
    if (!cpf || cpf.length < 11) return false;
    for (i = 0; i < cpf.length - 1; i += 1)
        if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
            digitosIguais = 0;
            break;
        }
    if (!digitosIguais) {
        numeros = cpf.substring(0, 9);
        digitos = cpf.substring(9);
        soma = 0;
        for (i = 10; i > 1; i -= 1)
            soma += numeros.charAt(10 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado.toString() !== digitos.charAt(0)) return false;
        numeros = cpf.substring(0, 10);
        soma = 0;
        for (i = 11; i > 1; i -= 1)
            soma += numeros.charAt(11 - i) * i;
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado.toString() !== digitos.charAt(1)) return false;
        return true;
    }
    return false;
}

function validateCartaoSus(numSus) {
    let cns = numSus;

    if (!cns) return false;

    cns = cns.replace(/\s/g, '');

    const validaTamanho = cns.length === 15;
    const validaInicio = ['1', '2', '7', '8', '9'].includes(cns[0]);

    if (validaTamanho && validaInicio) {
        // CNS Iniciados em 7, 8 ou 9
        if (['7', '8', '9'].includes(cns[0])) {
            const soma = cns.split('').reduce((total, value, index) => total + (value * (15 - index)), 0);
            return soma % 11 === 0;

        }
        // CNS Iniciados em 1, 2
        const pis = cns.substring(0, 11);
        const soma = pis.split('').reduce((total, value, index) => total + (value * (15 - index)), 0);

        const resto = soma % 11;
        const dv = resto === 0 ? 0 : 11 - resto;

        const resultado = dv === 10 ? `${pis}001${(11 - ((soma + 2) % 11))}` : `${pis}000${dv}`
        return resultado === cns;

    }

    return false;
}

function validatePis(pis) {
    const multiplicadorBase = "3298765432";
    let total = 0;
    let resto = 0;
    let multiplicando = 0;
    let multiplicador = 0;
    let digito = 99;

    // Retira a mascara
    const numeroPIS = pis.replace(/[^\d]+/g, '');

    if (numeroPIS.length !== 11 ||
        numeroPIS === "00000000000" ||
        numeroPIS === "11111111111" ||
        numeroPIS === "22222222222" ||
        numeroPIS === "33333333333" ||
        numeroPIS === "44444444444" ||
        numeroPIS === "55555555555" ||
        numeroPIS === "66666666666" ||
        numeroPIS === "77777777777" ||
        numeroPIS === "88888888888" ||
        numeroPIS === "99999999999") {
        return false;
    }
    for (let i = 0; i < 10; i += 1) {
        multiplicando = parseInt(numeroPIS.substring(i, i + 1), 10);
        multiplicador = parseInt(multiplicadorBase.substring(i, i + 1), 10);
        total += multiplicando * multiplicador;
    }

    resto = 11 - total % 11;
    resto = resto === 10 || resto === 11 ? 0 : resto;

    digito = parseInt(`${  numeroPIS.charAt(10)}`, 10);
    return resto === digito;

}

export {
    validateCpf,
    validateCartaoSus,
    validatePis
}